module.exports = __webpack_public_path__ + "img/insert-01-droit.80214a55.svg";